var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.604,
    height: 30,
    viewBox: "0 0 19.604 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "computer-mouse",
    d: "M82.865,0h-2.3a8.565,8.565,0,0,0-8.481,8.823V21.176A8.565,8.565,0,0,0,80.564,30h2.3a8.833,8.833,0,0,0,8.822-8.824V8.823A8.833,8.833,0,0,0,82.865,0ZM81.8,4.624h.178a.505.505,0,0,1,.5.5V8.722a.505.505,0,0,1-.5.5H81.8a.505.505,0,0,1-.5-.5V5.128A.505.505,0,0,1,81.8,4.624Zm8.737,16.552a7.678,7.678,0,0,1-7.668,7.67h-2.3a7.425,7.425,0,0,1-7.327-7.67V8.823a7.424,7.424,0,0,1,7.327-7.669H81.3V3.545a1.662,1.662,0,0,0-1.164,1.583V8.722A1.661,1.661,0,0,0,81.3,10.305v2.968a.577.577,0,1,0,1.154,0V10.309a1.661,1.661,0,0,0,1.178-1.587V5.128a1.661,1.661,0,0,0-1.178-1.587V1.154h.41a7.678,7.678,0,0,1,7.668,7.669Z",
    transform: "translate(91.687 30) rotate(180)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.2f4a10dbfa70dc7c0d3539ed557a3662.svg";
export { ForwardRef as ReactComponent };